import { CfModalType } from "./types";
import { ModalType } from "components/ModalLayout";

export const CF_MODAL_TYPE_DICTIONARY: { [key in CfModalType]: ModalType } = {
  full: "full-width",
  small: "small",
  large: "large",
  medium: "medium",
};
